
module.exports = {
  // TODO: change your profile information here
  name: "Rushikesh Jadhav",
  greeting: "Hey 👋",
  greetingDescription: "I'm Rushikesh Jadhav and I'm a Full-Stack development and Cyber security Enthusiastic!....",
  githubUrl: "https://github.com/rushi5791",
  linkedinUrl: "https://www.linkedin.com/in/rushikesh-jadhav-25269b1b4/",
  cvLink: "https://drive.google.com/file/d/1GlQT1-muTuz1iFcrReArPhzaC8sQPxw0/view",
};
